import { Component } from '@angular/core';
import { AppendTestIdPipe } from '../../../../pipes/append-test-id/append-test-id.pipe';
import { ErrorMessageComponent } from '../../../layout/error-message/error-message.component';
import { NgClass, NgStyle, NgTemplateOutlet } from '@angular/common';
import { NgControl, ReactiveFormsModule } from '@angular/forms';
import { FormInputComponent } from '../form-input.component';

@Component({
  selector: 'aw-static-form-field',
  imports: [
    AppendTestIdPipe,
    ErrorMessageComponent,
    NgTemplateOutlet,
    ReactiveFormsModule,
    NgClass,
    NgStyle,
  ],
  templateUrl: './static-form-field.component.html',
})
export class StaticFormFieldComponent extends FormInputComponent {
  constructor(public override ngControl: NgControl) {
    super(ngControl);
  }
}
